<!-- 配置路由页面 -->
<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('systemManagement') }}>{{ $t('ConfigureRouter') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('WifiName')">
            <el-input v-model="formInline.name" clearable :placeholder="$t('WifiName')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="searchList">{{ $t('query') }}</el-button>
            <el-button type="primary" class="add-btn" @click="addFace">{{ $t('generatWiFi') }}</el-button>
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                <p>1. {{ $t('configuredRealize') }}</p>
                <p>2. {{ $t('mobilePhoneHotspots') }}</p>
                <p>3. {{ $t('nameAndPassword') }}</p>
              </div>
              <el-button type="primary" class="add-btn"><i class="help_icon"></i>{{ $t('help') }}</el-button>
            </el-tooltip>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table 组件 -->
        <Table
          :data="tableData"
          :tableHeight="640"
          :columns="columns"
          :operation="dateOperation"
          @operate="operationEvent"
          :showSelcet="false"
          :operationWidth="100"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import { getHelmetWifi, addHelmetWifi, deleteHelmettWifi } from '@/api/setting'
import { success } from '@/util/common'
export default {
  data() {
    return {
      formInline: {
        name: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
    }
  },
  components: {
    Table,
  },
  methods: {
    // 点击新增按钮
    addFace() {
      this.$confirm(this.$t('addsWifi'), {
        confirmButtonText:  this.$t('determine'),
        cancelButtonText:  this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        addHelmetWifi().then(res => {
          if (res.state === 0) {
            this.dialogFace = false
            this.basicConfig()
            success(this.$t('AddSuccess'))
          }
        })
      })
    },

    // table 的按钮操作
    operationEvent(type, value, index) {
      if (type.type === 'delect') {
        this.delectInfo(type.value)
      }
    },
    // 删除信息
    delectInfo(row) {
      this.$confirm(this.$t('deleteThisInformation'), {
        confirmButtonText:  this.$t('determine'),
        cancelButtonText:  this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = { id: BigInt(row.id) }
        deleteHelmettWifi(param).then(res => {
          if (res.state === 0) {
            success(this.$t('deleteSuccess'))
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.basicConfig()
    },
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.searchList()
    },
    // 根据条件进行查询
    searchList() {
      this.currentPage = 1
      this.basicConfig()
    },
    // 基础配置信息，请求table数据
    basicConfig() {
      let param = {
        name: this.formInline.name,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getHelmetWifi(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
        }
      })
      // table header
      this.columns = [
        {
          attrName: 'name',
          label: this.$t('WifiName'),
          sort: 'name',
        },
        {
          attrName: 'password',
          label: this.$t('WifiPassword'),
          sort: 'password',
        },
        {
          attrName: 'createName',
          label: this.$t('createdBy'),
          sort: 'createName',
        },
        {
          attrName: 'createTime',
          label: this.$t('creationTime'),
          width: '180',
          align: 'center',
          sort: 'createTime',
        },
      ]
      // 操作
      this.dateOperation = [
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: '',
          class: 'editClick',
        },
      ]
    },
  },
  created() {
    this.basicConfig()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
@import '~@/style/mixin.styl'
.bg-contain
  .breadcrumb-tilte
    padding-left 54px !important
>>>.add-btn
    span
      display flex
      align-items: cneter
  .help_icon
    display: inline-block;
    width 16px;
    height 16px;
    margin-right 3px
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 635px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.el-tooltip__popper
  p
    line-height 30px
</style>
